export default __webpack_public_path__ + "static/media/ISWEC-7.c6191ed0.pdf";